import { render, staticRenderFns } from "./AddToHomeScreen.vue?vue&type=template&id=1293dd86&scoped=true"
import script from "./AddToHomeScreen.vue?vue&type=script&lang=js"
export * from "./AddToHomeScreen.vue?vue&type=script&lang=js"
import style0 from "./AddToHomeScreen.vue?vue&type=style&index=0&id=1293dd86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1293dd86",
  null
  
)

export default component.exports